export const DownloadField = [
    { text: "Reference Number", dataField: "Reference Number" },
    { text: "For Field", dataField: "For Field" },
    { text: "Startup Name", dataField: "Startup Name" },
    { text: "Created Date	", dataField: "Created Date	" },
    { text: "Application Date", dataField: "Application Date" },
    { text: "Archived", dataField: "Archived" },
    { text: "Deleted", dataField: "Deleted" },
    { text: "Status", dataField: "Status" },
    { text: "Incorporation Number", dataField: "Incorporation Number" },
    { text: "Recognition Number", dataField: "Recognition Number" },
    { text: "Industry", dataField: "Industry" },
    { text: "Section", dataField: "Section" },
    { text: "State", dataField: "State" },
    { text: "District", dataField: "District" },
    { text: "Employees", dataField: "Employees" },
    { text: "Stage", dataField: "Stage" },
    { text: "Note", dataField: "Note" },
    { text: "MOA Document", dataField: "MOA Document" },
   // { text: "Remapped District", dataField: "Remapped District" },
    { text: "Video URL", dataField: "Video URL" },
    { text: "Website", dataField: "Website" },
    { text: "Balance Sheet", dataField: "Balance Sheet" },
    { text: "Revenue", dataField: "Revenue" },
    { text: "Profit/Loss", dataField: "Profit/Loss" },
    { text: "ITR URLs", dataField: "ITR URLs" },
    { text: "PitchDeck URL", dataField: "PitchDeck URL" },
    { text: "Clarifications URLs", dataField: "Clarifications URLs" },
    { text: "Incomplete Count", dataField: "Incomplete Count" },
    { text: "Incomplete Reason", dataField: "Incomplete Reason" },
    { text: "Board Resolution", dataField: "Board Resolution" },
    { text: "Score", dataField: "Score" },
    // { text: "Startups with Women Directors", dataField: "Startups with Women Directors" },
    // { text: "Recognition Financial Year", dataField: "Recognition Financial Year" },
    // { text: "Tier 2/3 City", dataField: "Tier 2/3 City" },
    // { text: "Director Name 1", dataField: "Director Name 1" },
   // { text: "Director Gender 1", dataField: "Director Gender 1" },
    // { text: "Director mobileNumber 1", dataField: "Director mobileNumber 1" },
    // { text: "Director Email 1", dataField: "Director Email 1" },
    // { text: "NSA 2020", dataField: "NSA 2020"},
    // { text: "NSA 2021", dataField: "NSA 2021"},
    // { text: "NSA 2022", dataField: "NSA 2022"},
    // { text: "NSA 2023", dataField: "NSA 2023"},
    // { text: "SeedFund", dataField: "SeedFund Count"},
    // { text: "IE Tags", dataField: "IE Tags"},
    // { text: "Ministry Tags", dataField: "Ministry Tags"},
    // { text: "Corporate Tags", dataField: "Corporate Tags"},
    // { text: "80-IAC", dataField: "80-IAC"},

    // { text: "Director Gender 2", dataField: "Director Gender 2" },
    // { text: "Director Gender 3", dataField: "Director Gender 3" },
    // { text: "Director Gender 4", dataField: "Director Gender 4" },
    // { text: "Director Gender 5", dataField: "Director Gender 5" },
    // { text: "Director Gender 6", dataField: "Director Gender 6" },
    // { text: "Director Gender 7", dataField: "Director Gender 7" },
    // { text: "Director Gender 8", dataField: "Director Gender 8" },
    // { text: "Director Gender 9", dataField: "Director Gender 9" },
    // { text: "Director Gender 10", dataField: "Director Gender 10" },
    // { text: "Director Gender 11", dataField: "Director Gender 11" },
    // { text: "Director Gender 12", dataField: "Director Gender 12" },
    // { text: "Director Gender 13", dataField: "Director Gender 13" },
    // { text: "Director Gender 14", dataField: "Director Gender 14" },
    // { text: "Director Gender 15", dataField: "Director Gender 15" }
];